import { render, staticRenderFns } from "./bigScreennwo.vue?vue&type=template&id=520ea06e&scoped=true"
import script from "./bigScreennwo.vue?vue&type=script&lang=js"
export * from "./bigScreennwo.vue?vue&type=script&lang=js"
import style0 from "./bigScreennwo.vue?vue&type=style&index=0&id=520ea06e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ea06e",
  null
  
)

export default component.exports